import { Button, Divider, Icon } from '@beehive/components';
import { getAttachementUploadUrl } from 'containers/OutWorkbench/utils';
import _ from 'lodash';
import React from 'react';
import ajax from 'utils/ajax';
import { Button as BCButton } from "@bedrock/components";
import { openIframe } from "@mpc/common/src/features/utils";
import { ResponseInteger, ResponseString, outsourceContentMarketQueryGetDemandWorkNum, outsourceContentMarketQueryGenUpdateDataPageUrlForSupplier, outsourceDemandDownloadCaseTemplate } from 'services/api';
import { ChevronRight, RotateRight } from '@bedrock/icons-react';

export const FULL_COL_PROPS = {
  itemColProps: { span: 24 },
  itemLabelColProps: { span: 4 },
  itemInputColProps: { span: 20 },
};

export const UploadTips = (props: any) => {
  const { showDownloadTemp = true } = props;
  const downloadTemplate = () => {
    outsourceDemandDownloadCaseTemplate().then((res: any) => {
      res?.data && window.open(res?.data)
    })
  }

  const parentStyle = {
    display: 'inline-flex',
    gap: 10,
  };

  const marginLeftStyle = {
    marginLeft: 10,
  };

  return (
    <div style={parentStyle}>
      <span>(单个文件不超过200M)</span>
      {showDownloadTemp ? (
        <>
          <Divider vertical />
          <div>
            <Icon name="file-text-o" />
            <Button link onClick={downloadTemplate} style={marginLeftStyle}>
              结案报告模板下载
            </Button>
          </div>
        </>
      ) : null}
    </div>
  );
};

export const getDetailFileList = (detail: Record<string, any>) => {
  const attaches: any[] = detail['settle_report_attachs'] || [];
  const fileList = attaches
    .filter((attach: any) => !!attach.blob)
    .map((attach: any) => {
      return {
        uid: attach.blob.id,
        name: attach.blob.filename,
        size: attach.blob.byte_size,
        status: 'done',
        blob_id: attach.blob.id,
        blob_key: attach.blob.key,
      };
    });
  return fileList;
};

export const getFormItemList = (
  detail: any,
  onChange: Function,
  formData: Record<string, any>
) => {
  const {
    structured,
    product_area,
    non_need_fee_control_verify,
    need_content_marketing_attach,
    demand_suppliers,
    demand_advertising = {}
  } = detail

  const { dspf_offer_price, offer_currency_name } = demand_advertising;
  // 产品等于国内 并且 是喇叭体系-喇叭内容加热助推 、喇叭体系-喇叭内容传播加热-视频图文加热
  const isShowBoost = detail?.product_area === "DOMESTIC" && detail?.need_boost_effect_data
  const showUploadWork = need_content_marketing_attach === 1
  const showSignedStatementAttachs =
    !demand_suppliers?.[0]?.inner_supplier  // 是否供应商内采
    && structured // 是否结构化
    && product_area === 'DOMESTIC' // 是否国内
    && !non_need_fee_control_verify // 是否需走费控
  return [
    {
      key: 'quote_price_rmb',
      label: '报价金额',
      show: true,
      ...FULL_COL_PROPS,
      childProps: {
        value: `${dspf_offer_price ? dspf_offer_price : '待数易同步'} ${offer_currency_name ? offer_currency_name : ''
          }`,
      },
    },
    {
      key: 'final_settle_price',
      label: '最终结算金额',
      show: true,
      required: true,
      itemColProps: { span: 6 },
      itemLabelColProps: { span: 4 },
      childProps: {
        componentClass: 'inputNumber',
        currency: 'rmb',
        value: formData['final_settle_price'],
        onChange,
      },
    },
    {
      key: 'currency',
      label: '',
      show: true,
      itemColProps: { span: 6 },
      itemLabelColProps: { span: 0 },
      itemInputColProps: { span: 5, offset: 1 },
      childProps: {
        value: offer_currency_name || '',
      },
    },
    {
      key: 'upload_work',
      label: '上传作品',
      required: true,
      show: showUploadWork,
      childProps: {
        uploadKey: 'upload_work',
        type: 'link',
      },
    },
    {
      key: 'boost',
      label: '上传加热助推效果',
      required: true,
      show: isShowBoost,
      childProps: {
        uploadKey: 'boost',
      },
    },
    {
      key: 'signed_statement_attachs',
      label: '结算单附件',
      show: showSignedStatementAttachs,
      childProps: {
        type: 'attachment',
      }
    },
    {
      key: 'settle_report_attachs_blob_ids',
      label: '结案报告',
      show: true,
      required: true,
      childProps: {
        componentClass: 'upload',
        showUploadList: { showRemoveIcon: true },
        multiple: true,
        uploadTips: <UploadTips />,
        defaultFileList: getDetailFileList(detail),
        minSizeLimit: 0,
        uploadAction: getAttachementUploadUrl(),
        data: (file: any) => {
          return {
            model: 'SocialMedia::Project',
            filename: file.name,
            attach_type: 'settle_report_attachs',
          };
        },
        onChange: ({ formItemKey, value }: any) => {
          const { file } = value;
          const blob = _.get(file, 'response.data');
          let attachs = formData['settle_report_attachs_blob_ids'] || [];
          switch (file.status) {
            case 'done':
              attachs.push({ blob_id: blob.blob_id, blob_key: blob.blob_key });
              break;
            case 'removed':
              if (blob) {
                attachs = attachs.filter((a: any) => a.blob_id !== blob?.blob_id);
              } else {
                attachs = attachs.filter((a: any) => a.blob_id !== file.blob_id);
              }
              break;
            default:
              return;
          }
          onChange({ formItemKey, value: attachs });
        },
      },
    },
  ].filter(item => item.show);
};
